import * as vueToastifications from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin({
  setup(nuxtApp) {
    nuxtApp.vueApp.use(vueToastifications.default, {
      position: 'bottom-right',
      timeout: 5000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      showCloseButtonOnHover: false,
      hideProgressBar: false,
      closeButton: 'button',
      icon: true,
      rtl: false,
      toastClassName: 'easy-toastifications'
    })

    // Defer useToast() call to ensure the plugin is fully registered
    let toastInstance = null
    const getToast = () => {
      if (!toastInstance) {
        try {
          toastInstance = vueToastifications.useToast()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn('[toast] Failed to initialize toast:', e)
          return null
        }
      }
      return toastInstance
    }

    // Provide a lazy wrapper that initializes toast on first use
    nuxtApp.provide('toast', {
      success: (message, options) => getToast()?.success(message, options),
      error: (message, options) => getToast()?.error(message, options),
      warning: (message, options) => getToast()?.warning(message, options),
      info: (message, options) => getToast()?.info(message, options),
      clear: () => getToast()?.clear(),
      dismiss: (id) => getToast()?.dismiss(id)
    })
  }
})
